import * as React from 'react';
import {StyleSheet, Text, TextStyle, View, ViewStyle} from 'react-native';

import Coin from '../../shared/images/Coin';

import Episode from '../../../../domain/entities/Episode';

interface Props {
  episode: Episode;
}

const EpisodeVisibilityLabel: React.FunctionComponent<Props> = props => {
  const {episode} = props;
  if (episode.visibility == 'paid') {
    return (
      <View style={styles.containerPaid}>
        <Coin />
        <Text style={styles.textPaid}>{episode.amount}</Text>
      </View>
    );
  }
  if (episode.visibility == 'open_to_all') {
    return (
      <View style={styles.container}>
        <Text style={styles.text}>無料</Text>
      </View>
    );
  }
  return null;
};

export default React.memo(EpisodeVisibilityLabel);

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    paddingVertical: 5,
    paddingHorizontal: 6,
    backgroundColor: '#33a1dc',
  } as ViewStyle,
  text: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#fafafa',
  } as TextStyle,
  containerPaid: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    paddingVertical: 5,
    paddingHorizontal: 6,
    flexDirection: 'row',
  } as ViewStyle,
  textPaid: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 2,
  } as TextStyle,
});
